import React from 'react';
import TabDataIcon from '../../../Icons/TabDataStatus'

type Props = {
  values: any
};

const FlightsData = (props: Props) => {
  if (props.values && props.values.flight_attributes) {
    var values = Object.values(props.values.flight_attributes)
    for (var value of values) {
      if (value) {
        return <TabDataIcon />;
      }
    }
  }
  return null;
}

export default FlightsData;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/Helpers/TabData/Flights.tsx